"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdministrativeDocumentType = void 0;
/**
 * The different kinds of required administrative documents
 */
var AdministrativeDocumentType;
(function (AdministrativeDocumentType) {
    AdministrativeDocumentType["CRIMINAL_RECORD"] = "CRIMINAL_RECORD";
    AdministrativeDocumentType["CERTIFICATE_OF_INCORPORATION"] = "CERTIFICATE_OF_INCORPORATION";
    AdministrativeDocumentType["COMPLIANCE_FORM"] = "COMPLIANCE_FORM";
})(AdministrativeDocumentType = exports.AdministrativeDocumentType || (exports.AdministrativeDocumentType = {}));
//# sourceMappingURL=AdministrativeDocumentType.js.map